module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAAclBMVEUAAADMmTPVqivfv0DjqjnVqivTsDXTrzPZszPYsTbVsDPVsjTWsjTXsjXVsjPWsTXWsjTWsTTXsDPVsjPVsTPWsTTVsTXWsTXWsTTVsDTWsTTVsjTWsjXWsTTXsTTWsTPWsjTWsTXWsTTWsTTWsTTWsTSU9NJ7AAAAJXRSTlMABQYICQwdIyg0N0ljZm1vcHV4gYaJjKCnrK2yzNzj5O3u7/T35B9W0wAAAKJJREFUOMvV08cWwjAMRFHRezPFtBBCmP//RTYcY49kZ81b3yNpI9m+QT1mElrspyJKAOcgHPAciRY4RAKYCIDKJ+0GsbiIAPBi5gDg1i+QILLkJ3IkEhkSC5skwiSpsAgJg7DQRAlFUjE8XedMaIYDaiK8xQNIibpDEX0pEy2YbLRg8tKCyV0LJuPjuidlYvWnhB42rvqSjqTtEq2smrJolh+OiEIt+S1mDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_editing_gold_img.png
// module id = SD4f
// module chunks = 5